import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import SiteContentProvider from './SiteContent';
import useBusinessJsonLd from './useBusinessJsonLd';
import useUmamiPageview from './useUmamiPageview';
import useConversionTracking from './useConversionTracking';
import EditBar from './components/EditBar';
import './website.css';

/**
 * Rahmen aller öffentlichen Seiten: Header, Inhalt, Footer.
 * Kümmert sich zusätzlich um Scrollverhalten bei Seiten- und Ankerwechsel.
 *
 * Der [SiteContentProvider] sitzt hier und nicht in `App.tsx`: Die Texte der
 * Website gehen die interne Anwendung nichts an, und so werden sie auch nur
 * geladen, wenn tatsächlich eine öffentliche Seite geöffnet ist.
 */
const SiteLayout: React.FC = () => (
  <SiteContentProvider>
    <SiteFrame />
  </SiteContentProvider>
);

/** Der eigentliche Rahmen — getrennt, weil er die Texte des Providers braucht. */
const SiteFrame: React.FC = () => {
  const { pathname, hash } = useLocation();

  useBusinessJsonLd();
  useUmamiPageview();
  useConversionTracking();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="site">
      <a className="skip-link" href="#inhalt">
        Zum Inhalt springen
      </a>
      <SiteHeader />
      <main id="inhalt">
        <Outlet />
      </main>
      <SiteFooter />
      <EditBar />
    </div>
  );
};

export default SiteLayout;
